/**
 * GENERATED by scripts/gen-build-info.js — do not edit, do not commit.
 *
 * This file is gitignored. It is rewritten by the prestart / prebuild:prod /
 * prebuild:test hook before every start and every build, so whatever is here
 * describes the LAST LOCAL BUILD on this machine and nothing else.
 *
 * BUILD_DIRTY = tracked modifications only (untracked files are ignored).
 */
export const BUILD_SHA = '45c9b56';
export const BUILD_DIRTY = false;
